import {interfaceLocale,useLanguage} from '../i18n';
import React,{createContext,useContext} from 'react';
import {getMarket} from './market';
export const BusinessRegionContext=createContext({});
export function regionMoney(business={}) {
  const market=getMarket(business?.countryCode);
  return new Intl.NumberFormat(interfaceLocale(),{style:'currency',currency:business?.currency || market.currency,currencyDisplay:'code',minimumFractionDigits:2,maximumFractionDigits:2});
}
export function useRegionMoney() {useLanguage();return regionMoney(useContext(BusinessRegionContext));}
export function useBusinessRegion() {return useContext(BusinessRegionContext);}
export function assertSameCurrency(rows,business={}) {
  const currency=business?.currency || getMarket(business?.countryCode).currency;
  if(rows.some(row=>(row.currency || 'USD')!==currency))throw new Error('Hay registros con otra moneda. No podemos sumarlos en este reporte; contacta a soporte.');
  return rows;
}
